import { userGroupCreateFormSchema } from './create-form.js';
export const userGroupEditFormSchema = userGroupCreateFormSchema;
//# sourceMappingURL=update-form.js.map